import { Referral } from '@oh-vcp/components-common';
import { useQuery, useQueryClient } from 'react-query';
import apiService from './apiService';

const fetchReferral = async (referralId: string): Promise<Referral> => {
  const url = `ocean/eReferrals/${referralId}`;
  const response = await apiService.get(url);
  return response.data;
};

const useReferralLookup = (referralId: string | undefined) => {
  const queryClient = useQueryClient();

  const result = useQuery({
    enabled: !!referralId,
    queryFn: () => fetchReferral(referralId!),
    queryKey: ['useReferralLookup', referralId]
  });

  const fetchById = async (id: string): Promise<Referral> => {
    return queryClient.fetchQuery(['useReferralLookup', id], () => fetchReferral(id));
  };

  return {
    ...result,
    fetchById
  };
};

export default useReferralLookup;
